import { createTheme } from "@mui/material";

const theme = createTheme({
    palette:{
        primary:{
            main:'#0f4860'
        }
    },
    components: {
    }
})

export default theme